import { SET_DASHBOARD_NAME, SET_ACTIVE_SUB_ITEM } from "./types";

export const updateCurrentDashboard = (dashboard) => {
  return {
    type: SET_DASHBOARD_NAME,
    payload: dashboard,
  };
};

export const setActiveSubItem = (itemId) => {
  return {
    type: SET_ACTIVE_SUB_ITEM,
    payload: itemId,
  };
};
